import { fetchFactory } from 'isotope-client'

export const getAppProperties = () => fetchFactory('/properties', {}, '/api/public')
